/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorExecuteSql', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorExecuteSqlController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-execute-sql.html'),

      replace: true,

      scope: {
        component: '=',
      },

      link(scope, element, attrs) {},
    };
  },
]);
